import { makeObservable, observable, action } from 'mobx'
import {
  ProviderAutomation,
  ProviderAutomationFetchParams,
} from '../providers/types'
import BaseProvider from '../providers/BaseProvider'
import Automation from './Automation'
import Store from './Store'

export default class AutomationCollection {
  items: Automation[] = []
  store: Store
  provider: BaseProvider
  state: 'ready' | 'loading' | 'failed' = 'ready'

  constructor(store: Store) {
    makeObservable(this, {
      items: observable,
      state: observable,
      fromProvider: action,
      create: action,
      remove: action,
      // isLoading: computed,
      // isReady: computed,
    })
    this.store = store
    this.provider = store.provider
  }

  async fetch(params?: ProviderAutomationFetchParams) {
    try {
      const data = await this.provider.fetchAutomations(params)
      this.fromProvider(data)
      // console.log(this.state)
    } catch {
      // console.log(this.state)
    }
  }

  fromProvider = (data: ProviderAutomation[]) => {
    this.items = data.map((item) => {
      const instance = new Automation(this.store, this)
      instance.fromProvider(item)
      return instance
    })
  }

  create = (payload: {
    name: string
    day: string
    hour: string
    templateId: string
  }) => {
    const instance = new Automation(this.store, this)
    instance.name = payload.name
    instance.day = payload.day
    instance.hour = payload.hour
    instance.templateId = payload.templateId
    this.items.push(instance)
    void instance.create()
    return instance
  }

  remove = (id: string) => {
    this.items = this.items.filter((item) => item.id !== id)
  }
}
